import React, { useState } from "react";
import { FaPlay } from "react-icons/fa";

import img1 from "../../assets/images/others/video.jpg";

const Video = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handlePlayClick = (e) => {
    e.preventDefault();
    setShowVideo(true);
  };

  const handleCloseVideo = () => {
    setShowVideo(false);
  };

  return (
    <>
      <section
        id="call-to-action"
        className="py-5 container mx-auto"
        data-aos="fade-down"
      >
        <div className=" text-center relative p-4 rounded-2xl  ">
          <img
            src={img1}
            alt=""
            className="relative h-[480px] object-cover w-full rounded-2xl brightness-50"
          />

          <div className="absolute top-0 left-0 h-full w-full flex justify-center items-center   ">
            <div className=" flex flex-col items-center max-w-3xl px-3 py-2 md:px-5 md:py-3">
              {!showVideo && (
                <button
                  
                  className=" inline-block w-24 h-24 bg-blue-900 rounded-full relative opacity-90 cursor-pointer"
                  onClick={handlePlayClick}
                >
                  <span className="absolute inset-0 flex items-center justify-center text-white/95 text-xl">
                    
                      <FaPlay />
                    
                                      </span>
                  <span  className="absolute inset-0 flex items-center justify-center h-24 w-24 -z-[40] animate-ping transition-all duration-[120s]  rounded-full bg-red-200 opacity-30">


                  </span>
                </button>
              )}

              {showVideo && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
                  <video controls autoPlay className="max-w-[90%] max-h-[90%]">
                    <source src="../../assets/images/Video/video.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <button
                    className="absolute top-5 right-5 h-10 w-10  text-4xl bg-white m-auto rounded-full cursor-pointer z-50"
                    onClick={handleCloseVideo}
                  >
                    &times;
                  </button>
                </div>
              )}

              <h3 className="text-gray-50 text-2xl md:text-3xl font-bold mt-5 z-10 relative">
                Video Presentation
              </h3>
              <p className="text-neutral-200 mt-3 z-10 relative">
                Yogesh Aluminium Ladder: lightweight, durable, anti-slip steps.
                Perfect for home or professional use. Enhance safety and
                efficiency effortlessly!
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Video;
